export enum BidPackageStep {
  PACKAGE_DETAILS = "packageDetails",
  REVIEW_SCOPE = "reviewScope",
  SELECT_BIDDERS = "selectBidders",
  ASSIGN_TRADE_CONTACTS = "assignTradeContacts",
  REVIEW_AND_SEND = "reviewAndSend",
}
